/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { FancyActionableFirebase } from '../../common/fancy-firebase/generics/FancyActionableFirebase';
import { ActiveLine } from '../models/ActiveLine';
import { FancyAction } from '@touchplan/common';
import { ActiveLineObject } from '../../common/fancy-firebase/objects/ActiveLineObject';
/**
 * ActiveLineApi
 * Handles all of the Firebase "write" operations as well as local state changes.
 * You should not be using this class directly and instead should be going through ActiveLineService.
 */
export class ActiveLineApi extends FancyActionableFirebase<ActiveLine, FancyAction, ActiveLineObject> {
	constructor(data: ActiveLineObject) {
		super(data);
	}
}
